import { SuperadminReportsActionTypes } from './../constants/ApiConstants';

const initialState = {
  loading: false,
  master_data: null
};
export default (state = initialState, { type, payload }) => {
  switch (type) {
    case SuperadminReportsActionTypes.get_master_data.REQUEST:
    return {
      ...state,
      loading: true,
      master_data: null,
    };
  case SuperadminReportsActionTypes.get_master_data.SUCCESS:
    return {
      ...state,
      loading: false,
      master_data: payload,
    };

  default:
    return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/Superadmin/components/Reports/reducers/index.js